import NextImage from 'next/image';

// eslint-disable-next-line jsx-a11y/alt-text
function Image({ ...rest }) {
  return <NextImage {...rest} />;
}

export default Image;
